var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Logo',{attrs:{"size":275}}),_c('Name',{attrs:{"name":'Sxtanna'}}),_c('Link'),_c('br'),_c('Pins',{attrs:{"count":6}}),_c('Lang')],1)}
var staticRenderFns = []

export { render, staticRenderFns }